import { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@components/Button';
import Tooltip from '@components/Tooltip';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import { usePopupZIndex } from '@components/Modal/popupLayer';

const AddDropdownHeader = ({
    title,
    subtitle,
    disabled,
    disabledTooltip,
    options,
    onAdd,
    buttonText,
    MenuComponent = Menu,
    menuProps,
    buttonProps,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const { t } = useTranslation();
    const popupZIndex = usePopupZIndex();

    const handleAdd = value => {
        setAnchorEl(null);
        onAdd(value);
    };

    const MenuEl = MenuComponent;

    return (
        <>
            {(title || subtitle) && (
                <div>
                    {title && <Typography variant="body2">{title}</Typography>}
                    {subtitle && (
                        <Typography
                            variant="caption"
                            sx={{ color: 'var(--text-secondary)', display: 'block', margin: '4px 0 8px' }}
                        >
                            {subtitle}
                        </Typography>
                    )}
                </div>
            )}
            <div>
                <Tooltip title={disabled && disabledTooltip ? disabledTooltip : ''} placement="top">
                    <span>
                        <Button
                            variant="outlined"
                            onClick={e => setAnchorEl(e.currentTarget)}
                            disabled={disabled}
                            endIcon={anchorEl ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            sx={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}
                            {...buttonProps}
                        >
                            {buttonText || t('buttons.add')}
                        </Button>
                    </span>
                </Tooltip>
                <MenuEl
                    anchorEl={anchorEl}
                    open={!!anchorEl}
                    onClose={() => setAnchorEl(null)}
                    {...menuProps}
                    sx={{ zIndex: popupZIndex, ...menuProps?.sx }}
                >
                    {options.map(opt => {
                        const label = <Typography variant="body2">{t(opt.label)}</Typography>;
                        return (
                            <MenuItem
                                key={opt.value}
                                disabled={opt.disabled}
                                onClick={opt.disabled ? undefined : () => handleAdd(opt.value)}
                                sx={opt.tooltip ? { '&.Mui-disabled': { pointerEvents: 'auto' } } : undefined}
                            >
                                {opt.tooltip ? (
                                    <Tooltip title={opt.tooltip} placement="right">
                                        {label}
                                    </Tooltip>
                                ) : (
                                    label
                                )}
                            </MenuItem>
                        );
                    })}
                </MenuEl>
            </div>
        </>
    );
};

export default AddDropdownHeader;
